'use client';

import { Grid, TextLink } from '@petsmart-ui/sparky';

import { AccountDrawerType, usePageLayout } from '@libs/common-next';

export type ForgotPasswordCtaProps = {
    componentClassname?: string;
    webUrl?: string;
    actionText?: string;
};

export function ForgotPasswordCta({ componentClassname, webUrl, actionText }: Readonly<ForgotPasswordCtaProps>) {
    const { openAccountDrawer } = usePageLayout();

    return (
        <Grid.Item className={`${componentClassname}__forgot-password`}>
            <TextLink
                href={webUrl ?? '#'}
                data-testid="forgot-password-link"
                onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
                    if (!webUrl) {
                        event.preventDefault();
                        openAccountDrawer(AccountDrawerType.FORGOT_PASSWORD);
                    }
                }}
            >
                {actionText ?? 'Forgot password?'}
            </TextLink>
        </Grid.Item>
    );
}
